import React, { useEffect, useState } from "react";
import Layout from "./Layout";
import { Col } from "react-bootstrap";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import ProfileLayout from "./ProfileLayout";
import { RxCross2 } from "react-icons/rx";
import { useContext } from "react";
import AuthContext from "../context/AuthContext";
const Promotional = () => {
  const [data, setData] = useState([]);
  const { profileData } = useContext(AuthContext);
  const getFilteredOfferList = (count, list) => {
    const depositKeysToRemove = [
      "OnFirstDeposit",
      "OnSecondDeposit",
      "OnThirdDeposit",
      "OneFourthDeposit",
    ];

    const keysToRemove = depositKeysToRemove.slice(0, count);
    return list.filter((offer) => !keysToRemove.includes(offer.offerOn));
  };
  const getData = async () => {
    const { status, data } = await apiGet(apiPath.getPromotional);
    if (status == 200) {
      if (data?.success) {
        let updated = getFilteredOfferList(
          profileData?.userDepositCount,
          data?.results?.offerList
        );
        setData(updated);
      }
    }
  };
  const navigate = useNavigate();
  useEffect(() => {
    getData();
  }, [profileData]);
  function getTimeDifferenceString(currentTime, endTime) {
    const now = moment(currentTime);
    const end = moment(endTime);

    if (end.isBefore(now)) {
      return "Ended";
    }

    const duration = moment.duration(end.diff(now));
    const days = Math.floor(duration.asDays());
    const hours = duration.hours();

    return `End in ${days} days ${hours} hours`;
  }
  return (
    <Layout>
      <Col md={12}>
        <div>
          <div
            className="balance-label position-relative"
            style={{ paddingLeft: "10px" }}
          >
            Promotional
            <button className="bg-transparent border-0 text-white position-absolute end-0 pt-0">
              <RxCross2
                className="fs-3"
                style={{ fontWeight: "800", color: "black" }}
                onClick={() => navigate("/")}
              />
            </button>
          </div>
          <div className="container-1200">
            <div className="promotion-card-wrap main-tab-content">
              <section className="tab-pane never-join active">
                <ul
                  id="promotion_container"
                  className="filter-container promotion-card "
                  style={{
                    position: "relative",
                    display: "flex",
                    width: "100%",
                    margin: "0",
                    padding: "0",
                    flexWrap: "wrap",
                  }}
                >
                  {data?.map((res) => {
                    return (
                      <li
                        id="promotion-127170"
                        className="filtr-item"
                        data-category="4, 99"
                        title="100% Refund Bonus"
                        style={{ width: "25%" }}
                      >
                        <div className="card-inner">
                          <div className="img-wrap">
                            <img
                              ui-key="image"
                              src={`${process.env.REACT_APP_API_BASE_URL}${res?.offerImage}`}
                            />
                          </div>
                          <div className="explanation-wrap">
                            <div className="line" />
                            <div className="tag" ui-key="endDuration">
                              {getTimeDifferenceString(
                                new Date(),
                                res?.offerEndDateTime
                              )}
                            </div>
                            <h3 ui-key="title">{res?.title}</h3>
                            <p className="text" ui-key="description">
                              {res?.description}
                            </p>
                            <p className="time" style={{ opacity: 1 }}>
                              {moment(res?.offerStartDateTime).format(
                                "MMMM Do YYYY, h:mm:ss a"
                              )}{" "}
                              -
                              {moment(res?.offerEndDateTime).format(
                                "MMMM Do YYYY, h:mm:ss a"
                              )}
                            </p>
                            {res?.category == "Deposit" && (
                              <span
                                onClick={() => navigate(`/deposit/${res?._id}`)}
                                style={{
                                  color: "black",
                                  padding: "6px",
                                  borderRadius: "3px",
                                  cursor: "pointer",
                                }}
                                className="btn-default-xs deposit btn-deposit"
                              >
                                Deposit
                              </span>
                            )}
                            {/* <a
                              className="btn-default-xs detail btn-details"
                              data-id="promotion-127170"
                              data-pk={127170}
                              data-type={1}
                              data-messagetype={3}
                            >
                              <ui-translate
                                key="ui.text.promotion.bj.promo_detail"
                                lang="en"
                              >
                                Details
                              </ui-translate>
                            </a> */}
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </section>
            </div>
          </div>
        </div>
      </Col>
    </Layout>
  );
};

export default Promotional;
